<template>
	<v-card>
		<v-container>
			<agency-contest-form-panel v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"/>
		</v-container>
	</v-card>
</template>

<script>

	import AgencyContestFormPanel from "./components/AgencyContestFormPanel";

	export default {
		name: "ContestFormsView",
		components: {AgencyContestFormPanel},
		data() {
			return {
				contestDialog: false,

				chosenContest: undefined,

				chooseContestDialog: false,
			};
		},

		methods: {
			formChosen() {
				this.$messagesBus.$emit("success", "Formularz został wybrany z konkursu");
			},

			formDeleted() {
				this.$messagesBus.$emit("success", "Formularz został usunięty");
			},
		},
	};

</script>

<style scoped>

</style>
